import doRequest from '@/api/dssRequest';
import store from '../store';

export default class ComponentLoader {
  ResponseArray = [];

  getInfoForKeys(routerPath) {
    let keys = this.getKeysFromPath(routerPath);

    const payload = {
      Url: store.getters.getPartnerGroupUrl,
      Keys: keys,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          this.parseData(response);
          resolve();
        },
        (error) => {
          reject(error);
        },
        'getInfoForKeys',
        'LocationsNode_PGSE',
        payload,
        'GET'
      );
    });
  }

  parseData(response) {
    this.ResponseArray = [...response.data.ResponseArray];
  }

  isEventType() {
    for (const element of this.ResponseArray) {
      if (element.Type === 'Event') {
        return true;
      }
    }
    return false;
  }

  getEventId() {
    for (const element of this.ResponseArray) {
      if (element.Type === 'Event') {
        /*
        // Test if the event is a Theme, by looking it up in the themes table. If so, return the first child.
        // Themes have suggestions configured, which become the child of Theme events.
        // We want to see the first suggestion, if the url referred to a Theme event. Otherwise, return the Theme.
        for (const theme of store.getters['Account/themes']) {
          if (element.Id === theme.EventId) {
            if (theme.Children.length > 0) {
              console.log(
                `ComponentLoader - Event [${element.Id}] is a Theme. Going to return the first child.`
              );
              return theme.Children[0].EventId;
            }
          }
        }*/
        return element.Id;
      }
    }
    return -1;
  }

  getKeyForEvent() {
    for (const element of this.ResponseArray) {
      if (element.Type === 'Event') {
        return element.Key;
      }
    }
    return;
  }

  getKeysFromPath(routerPath) {
    var keys = [];
    var path = routerPath;

    // Because the split function includes empty strings before the first '/' char and after the last '/' char,
    // we need to remove the first and last '/', if they are present.
    // If the first char is a '/', remove it.
    if (path.charAt(0) === '/') {
      path = path.slice(1);
    }
    // If the last char is a '/', remove it.
    if (path.charAt(path.length - 1) === '/') {
      path = path.slice(0, -1);
    }
    keys = path.split('/');

    return keys;
  }
}
